// This file is automatically generated. DO NOT EDIT.

import { getCoreURL, toQueryParam } from '@api/internal';

export interface GetPinOnImageResultsRequest {
  region: 'eu' | 'us';
  userAuth?: string | undefined;
  interactiveContentId: string;
  session?: number;
}

export function getPinOnImageResultsRequest(
  requestParams: GetPinOnImageResultsRequest,
): Request {
  const queryParams = new URLSearchParams();
  if (requestParams.session !== undefined) {
    queryParams.set('session', toQueryParam(requestParams.session));
  }

  const coreURL = getCoreURL(requestParams.region);
  const queryString = queryParams.size > 0 ? `?${queryParams.toString()}` : '';
  const url = `${coreURL}/presentation/interactive-content/${requestParams.interactiveContentId}/pin-on-image-results${queryString}`;
  return new Request(url, {
    method: 'GET',
    headers: {
      ...(requestParams.userAuth && {
        Authorization: `Bearer ${requestParams.userAuth}`,
      }),
    },
  });
}
